import { cn } from "../../lib/utils";
import { forwardRef } from "react";

const Input = forwardRef(
  ({ label, name, error, type = "text", className, ...rest }, ref) => {
    const isTextarea = type === "textarea";

    const sharedProps = {
      ref,
      id: name,
      name,
      ...(!isTextarea && { type }),
      className: cn(
        "w-full border border-slate-300 rounded-lg px-3 py-2 text-sm",
        "focus:outline-none focus:ring-2 focus:ring-carex-500 focus:border-carex-500",
        "transition-colors duration-200",
        isTextarea && "resize-y min-h-[80px]",
        error && "border-red-500 focus:ring-red-500 focus:border-red-500",
        className
      ),
      ...rest,
    };

    return (
      <div className="space-y-1">
        {label && (
          <label
            htmlFor={name}
            className="block text-sm font-medium text-slate-700"
          >
            {label}
          </label>
        )}
        {isTextarea ? <textarea {...sharedProps} /> : <input {...sharedProps} />}
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
